import { Carrier } from "@/pages/mill/carriers/models/Carrier";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import {
	assemblyStatusCodes,
	CarrierAssemblyStatusTag,
} from "../components/CarrierAssemblyStatusTag";

type Props = {};
export const useLastInstancesTableData = ({}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "CreatedAt",
			headerName: "Timestamp",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Carrier)?.CreatedAt,
					"MM/dd/yy HH:mm",
				) || "",
		},
		{
			field: "SectionName",
			headerName: "Section | Stand | Letter",
			minWidth: 20,
			flex: 1.5,
			valueGetter: (params) =>
				`${(params.data as Carrier).SectionName ?? ""} - ${
					(params.data as Carrier).StandName ?? ""
				} - ${(params.data as Carrier).RollsetLetter ?? ""}`,
		},
		{
			field: "CarrierData",
			headerName: "Top Roll | Bottom Roll",
			minWidth: 20,
			flex: 2,
			valueGetter: (params) =>
				`${
					(params.data as Carrier).TopRollName
						? `${(params.data as Carrier).TopRollName} | `
						: ""
				}${
					(params.data as Carrier).BottomRollName
						? `${(params.data as Carrier).BottomRollName}`
						: ""
				}`,
		},
		{
			field: "SignedOffAt",
			headerName: "Signed Off",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Carrier)?.SignedOffAt,
					"MM/dd/yy HH:mm",
				) || "",
		},
		{
			field: "SignOffOperatorName",
			headerName: "Operator",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "InstalledAt",
			headerName: "Installed",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Carrier)?.InstalledAt,
					"MM/dd/yy HH:mm",
				) || "",
		},
		{
			field: "UninstalledAt",
			headerName: "Uninstalled",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Carrier)?.UninstalledAt,
					"MM/dd/yy HH:mm",
				) || "",
		},
		{
			field: "RollStatusCode",
			headerName: "Status",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				assemblyStatusCodes.find(
					(code) => code.Code === (params.data as Carrier).CarrierStatusCode,
				)?.Name,
			cellRenderer: CarrierAssemblyStatusTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				status: assemblyStatusCodes.find(
					(code) => code.Code === (params.data as Carrier).CarrierStatusCode,
				),
			}),
		},
	];
	return { columnDefs };
};
